import useStatusItems from './useStatusItems';
import useTypeItems from './useTypeItems';
import useDefaultAllItems from './useDefaultAllItems';

const tableHeaders = [
  'betId',
  'userId',
  'createdAt',
  'type',
  'provider',
  'amount',
  'currency',
  'coef',
  'possibleWinAmount',
  'status',
  'blank',
]

export {
  tableHeaders,
  useStatusItems,
  useTypeItems,
  useDefaultAllItems
}
